<template>
    <div class="info-popover-container d-inline-block">
      <button 
        type="button" 
        class="btn btn-link p-0 border-0 bg-transparent"
        data-bs-toggle="modal" 
        data-bs-target="#mindestvertragsdauerModal"
        aria-label="Hinweis zur Mindestvertragsdauer"
      >
        <info_icon_blau></info_icon_blau>
      </button>
    </div>
  
    <!-- Bootstrap Modal -->
    <div class="modal fade" id="mindestvertragsdauerModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content info-popover-modal">
          <div class="modal-header border-0 pb-2 text-start d-flex flex-row align-items-center">
            <span class="ms-2 me-3">
              <info_icon_blau></info_icon_blau>
            </span>
            <div>
              <strong>Hinweis</strong>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
          </div>
          <div class="modal-body ps-4 pe-3 pb-3 text-start">
            Die Mindestvertragsdauer beträgt ein Versicherungsjahr, sofern als Versicherungsbeginn der 01.01. eines Kalenderjahres vereinbart wurde. Bei unterjährigem Versicherungsbeginn, also nach dem 01.01., beträgt die Mindestversicherungsdauer zwei Versicherungsjahre. Das erste Versicherungsjahr endet zum 31.12. des Kalenderjahres, in dem das Versicherungsverhältnis beginnt.
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import info_icon_blau from '@/components/icons/info_icon_blau.vue';
  </script>
  
  <style scoped>
  .info-popover-modal {
      border: none;
      background: linear-gradient(to right, var(--vigo-1-500-bg) 0%, var(--vigo-1-500-bg) 7px, var(--vigo-5-100-bg) 7px, var(--vigo-5-100-bg) 100%);
      border-radius: var(--vigo-border-radius-md);
      font: var(--vigo-font-base);
      max-width: 600px;
  }
  
  .btn-link {
      text-decoration: none;
  }
  
  .btn-link:hover {
      text-decoration: none;
  }
  </style>
  